import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { Setting } from '../App';
import ChangeDeliverDate from '../components/SubscriptionList/ChangeDeliverDate';
import OtherMenu from '../components/SubscriptionList/OtherMenu';
import { billingPolicyIntervals } from '../constants';
import { useMetafieldData } from '../hooks/use-metafield-data';
import { useSubscriptionDetailListItem } from '../hooks/use-subscription-detail-list-item';
import base from '../styles/Base.module.css';
import style from '../styles/SubscriptionList.module.css';
import { calculateChangeDeadline } from '../utils/calculateChangeDeadline';

const SubscriptionItem: FC<{ setting: Setting; subscriptionContractId: string; last: boolean }> = ({
  setting,
  subscriptionContractId,
  last,
}) => {
  const { subscription, deliveryDate, updateSubscription } = useSubscriptionDetailListItem(setting, subscriptionContractId);
  const { addRequiredInfo, getRegistrableVariants } = useMetafieldData();
  const [productsInfo, setProductsInfo] = useState<any[]>([]);

  useEffect(() => {
    if (!subscription) return;

    const fetchProductsInfo = async () => {
      const products = await Promise.all(
        subscription.subscriptionLines.map(async (subscriptionLine) => {
          const productInfo = await getRegistrableVariants(subscriptionLine.productId);
          return productInfo;
        }),
      );
      setProductsInfo(products.filter((product) => !!product));
    };

    fetchProductsInfo();
  }, [subscription]);

  // const [changeDeadline, setChangeDeadline] = useState<dayjs.Dayjs>();

  // useEffect(() => {
  //   console.log('Subscription 更新されました:', subscription);
  //   // ここに必要な処理を記述
  // }, [subscription]); // subscription が変更された時に実行されます

  if (!subscription) {
    return <></>;
  }
  // console.log('subscription in SubscriptionItem', subscription);
  // console.log('subscription deliveryDate in SubscriptionItem', deliveryDate);

  let nextDeliveryDate = <></>;
  let nextDeliveryTime = <></>;
  if (deliveryDate && deliveryDate.current) {
    if (
      subscription.shop.showDelivery ||
      subscription.shop.mypageChangeDeliveryDays ||
      subscription.shop.showSkip ||
      subscription.shop.showPause
    ) {
      nextDeliveryDate = (
        <>
          {subscription.shop.showDelivery ? (
            <>
              {subscription.status === 'ACTIVE' ? (
                deliveryDate!.noDay ? (
                  '指定なし'
                ) : (
                  <>
                    {deliveryDate.current.format('YYYY/M/D')}
                    <br />
                    {/* {subscription.deliveryTimeText} */}
                  </>
                )
              ) : (
                '-'
              )}
            </>
          ) : (
            <></>
          )}
        </>
      );

      nextDeliveryTime = (
        <>
          {subscription.shop.showDelivery ? (
            <>{subscription.status === 'ACTIVE' ? <>{subscription.deliveryTimeText}</> : '-'}</>
          ) : (
            <></>
          )}
        </>
      );
    }
  }

  console.log('subscriptionContractId nextDeliveryDate', `${subscriptionContractId} ${nextDeliveryDate}`);

  // 変更締め切り日
  // ================================================
  const changeDeadline = calculateChangeDeadline(subscription);

  // 商品スライダー
  // ================================================
  function SliderNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} slider-next-arrow`}
        style={{ ...style, display: 'block', background: 'none' }}
        onClick={onClick}
      >
        <span>
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_605_222)">
              <path
                d="M30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15Z"
                fill="#000000"
              />
              <path
                d="M14.1798 19.7912C14.1135 19.7249 14.0609 19.6461 14.025 19.5595C13.9891 19.4728 13.9706 19.38 13.9706 19.2862C13.9706 19.1924 13.9891 19.0995 14.025 19.0129C14.0609 18.9262 14.1135 18.8475 14.1798 18.7812L17.2448 15.7152H10.6588C10.4693 15.7152 10.2876 15.6399 10.1536 15.5059C10.0196 15.3719 9.94434 15.1902 9.94434 15.0007C9.94434 14.8112 10.0196 14.6294 10.1536 14.4955C10.2876 14.3615 10.4693 14.2862 10.6588 14.2862H17.2448L14.1798 11.2192C14.0459 11.0852 13.9707 10.9036 13.9707 10.7142C13.9707 10.5248 14.0459 10.3431 14.1798 10.2092C14.3138 10.0752 14.4954 10 14.6848 10C14.8742 10 15.0559 10.0752 15.1898 10.2092L19.4758 14.5002C19.5494 14.573 19.6061 14.6611 19.6418 14.7582V14.7712V14.7772V14.7862V14.7952V14.8022V14.8132V14.8262V14.8412V14.8572V14.8732V14.8892V14.9042V14.9182V14.9702C19.6418 14.9762 19.6418 14.9822 19.6418 14.9882C19.6418 14.9942 19.6418 15.0002 19.6418 15.0062V15.0132C19.6418 15.0132 19.6418 15.0202 19.6418 15.0242V15.1112V15.1202V15.1292V15.1372V15.1482V15.1532V15.1662V15.1822C19.6087 15.2994 19.5461 15.4061 19.4598 15.4922L15.1898 19.7912C15.1235 19.8575 15.0448 19.9101 14.9582 19.946C14.8715 19.9819 14.7786 20.0004 14.6848 20.0004C14.591 20.0004 14.4982 19.9819 14.4115 19.946C14.3249 19.9101 14.2461 19.8575 14.1798 19.7912Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_605_222">
                <rect width="30" height="30" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
    );
  }

  function SliderPrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} slider-prev-arrow`}
        style={{ ...style, display: 'block', background: 'none' }}
        onClick={onClick}
      >
        <span>
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.31134e-06 15C5.87108e-07 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 -5.87108e-07 15 -1.31134e-06C6.71573 -2.03558e-06 2.03558e-06 6.71573 1.31134e-06 15Z"
              fill="#000000"
            />
            <path
              d="M15.8202 10.2088C15.8865 10.2751 15.9391 10.3539 15.975 10.4405C16.0109 10.5272 16.0294 10.62 16.0294 10.7138C16.0294 10.8076 16.0109 10.9005 15.975 10.9871C15.9391 11.0738 15.8865 11.1525 15.8202 11.2188L12.7552 14.2848L19.3412 14.2848C19.5307 14.2848 19.7124 14.3601 19.8464 14.4941C19.9804 14.6281 20.0557 14.8098 20.0557 14.9993C20.0557 15.1888 19.9804 15.3706 19.8464 15.5045C19.7124 15.6385 19.5307 15.7138 19.3412 15.7138L12.7552 15.7138L15.8202 18.7808C15.9541 18.9148 16.0293 19.0964 16.0293 19.2858C16.0293 19.4752 15.9541 19.6569 15.8202 19.7908C15.6862 19.9248 15.5046 20 15.3152 20C15.1258 20 14.9441 19.9248 14.8102 19.7908L10.5242 15.4998C10.4506 15.427 10.3939 15.3389 10.3582 15.2418L10.3582 15.2288L10.3582 15.2228L10.3582 15.2138L10.3582 15.2048L10.3582 15.1978L10.3582 15.1868L10.3582 15.1738L10.3582 15.1588L10.3582 15.1428L10.3582 15.1268L10.3582 15.1108L10.3582 15.0958L10.3582 15.0818L10.3582 15.0298C10.3582 15.0238 10.3582 15.0178 10.3582 15.0118C10.3582 15.0058 10.3582 14.9998 10.3582 14.9938L10.3582 14.9868C10.3582 14.9868 10.3582 14.9798 10.3582 14.9758L10.3582 14.8888L10.3582 14.8798L10.3582 14.8708L10.3582 14.8628L10.3582 14.8518L10.3582 14.8468L10.3582 14.8338L10.3582 14.8178C10.3913 14.7006 10.4539 14.5939 10.5402 14.5078L14.8102 10.2088C14.8765 10.1425 14.9552 10.0899 15.0418 10.054C15.1285 10.0181 15.2214 9.99957 15.3152 9.99957C15.409 9.99957 15.5018 10.0181 15.5885 10.054C15.6751 10.0899 15.7539 10.1425 15.8202 10.2088Z"
              fill="white"
            />
          </svg>
        </span>
      </div>
    );
  }
  const slider_settings = {
    variableWidth: true,
    arrows: true,
    infinite: false,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
  };

  // console.log({productsInfo})

  return (
    <div
      className={style.subscriptionContract}
      key={subscriptionContractId}
      // to={`/subscriptions/${encodeURIComponent(subscription.subscriptionContractId)}`}
    >
      {/* 定期便ID */}
      <p className={style.subscriptionContractId}>
        定期便ID：#{subscriptionContractId.replace(/gid:\/\/shopify\/SubscriptionContract\//g, '')}
      </p>
      {/* 契約情報見出し */}
      <div className={style.subscriptionContractHeader}>
        <img src="/image/icon_box.svg" width={35} height={35} className={style.subscriptionContractHeaderIcon} alt="" />
        {/* 契約情報詳細 */}
        <div className={style.subscriptionContractHeaderInfo}>
          <p className={`${base.baseBlack600} ${style.subscriptionContractHeaderKey}`}>
            次回お届け予定日
            <span className={`${base.baseBlack600} ${style.subscriptionContractHeaderValue}`}>
              {nextDeliveryDate}
              {/* {dayjs(subscription.nextBillingDate).format('YYYY/MM/DD')} */}
            </span>
          </p>
          <p className={`${base.baseBlack600} ${style.subscriptionContractHeaderKey}`}>
            次回お届け時間帯
            <span className={`${base.baseBlack600} ${style.subscriptionContractHeaderValue}`}>{nextDeliveryTime}</span>
          </p>
          <p className={`${base.baseBlack600} ${style.subscriptionContractHeaderKey}`}>
            配送頻度
            <span className={`${base.baseBlack600} ${style.subscriptionContractHeaderValue}`}>
              {subscription.billingPolicyIntervalCount + billingPolicyIntervals[subscription.billingPolicyInterval]}
            </span>
          </p>
          <p className={`${base.baseBlack600} ${style.subscriptionContractHeaderKey}`}>
            変更締切日時
            <span className={`${base.baseBlack600} ${style.subscriptionContractHeaderValue}`}>
              {dayjs(changeDeadline).format('YYYY/MM/DD HH:mm')}
            </span>
          </p>
        </div>
        {/* 契約情報詳細 ここまで */}
        {/* 契約情報変更 */}
        <div className={style.subscriptionContractHeaderMenus}>
          <Link
            to={`/subscriptions/${encodeURIComponent(subscriptionContractId)}`}
            className={style.subscriptionContractHeaderMenusButton}
          >
            <img src="/image/button_changenum.svg" alt="商品/個数の確認・変更" />
          </Link>
          <ChangeDeliverDate
            setting={setting}
            subscriptionContractId={subscription.subscriptionContractId}
            updateSubscription={updateSubscription}
          />
          <OtherMenu
            setting={setting}
            subscriptionContractId={subscription.subscriptionContractId}
            updateSubscription={updateSubscription}
            last={last}
          />
        </div>
        {/* 契約情報変更 ここまで */}
      </div>
      {/* 契約情報見出しここまで */}

      {/* 契約情報本体 */}
      <div className={style.subscriptionContractBody}>
        <div className={style.subscriptionContractBodyProducts}>
          {subscription.status === 'ACTIVE' ? (
            <Slider {...slider_settings}>
              {subscription.subscriptionLines.map((subscriptionLine, slIndex) => {
                const productInfo = productsInfo.find((productInfo) => productInfo.productId === subscriptionLine.productId);

                const image = productInfo?.featuredImage ? productInfo.featuredImage : subscriptionLine.variantImage;

                return (
                  <div className={style.subscriptionLine} key={`sl_${slIndex}`}>
                    {/* 商品情報 */}
                    <div className={style.subscriptionLineContent}>
                      <div className={style.subscriptionLineContentLink}>
                        {/* 商品画像 */}
                        <div className={style.subscriptionLineImageBlock}>
                          <img src={image} alt={subscriptionLine.title} className={`${style.subscriptionLineImage}`} />
                        </div>

                        {/* 商品名・価格・個数 */}
                        <div className={style.subscriptionLineContentBlock}>
                          <h3 className={style.subscriptionLineContentTitle}>{subscriptionLine.title}</h3>
                          {/* <p className={style.subscriptionLineContentPrice}>
                            価格：
                            <NumericFormat
                              displayType="text"
                              value={subscriptionLine.currentPriceAmount}
                              thousandSeparator={true}
                              suffix={'円'}
                            />
                          </p> */}
                          {/* <p className={style.subscriptionLineContentQuantity}>個数：{subscriptionLine.quantity}</p> */}
                        </div>
                      </div>
                    </div>
                    {/* 商品情報ここまで */}
                  </div>
                );
              })}
            </Slider>
          ) : (
            <></>
          )}
        </div>

        {/* 支払い情報 */}
        <div className={style.subscriptionContractBodyPaymentBlock}>
          {/* 支払情報上部セクション */}
          <div className={style.subscriptionContractBodyPaymentTop}>
            {/* 支払方法・支払い金額 */}
            <div className={style.subscriptionContractBodyPayment}>
              {/* <p className={`${base.baseGray400} ${style.subscriptionContractBodyPaymentPaymentType}`}>
            支払い方法: <span className={base.baseBlack600}>{subscription.paymentType}</span>
          </p> */}

              {/* <p className={base.baseGray400}>
                支払い金額:
                <span className={base.baseBlack600}>
                  <NumericFormat
                    displayType="text"
                    value={subscription.deliveryPriceAmount}
                    thousandSeparator={true}
                    suffix={'円'}
                  />
                </span>
              </p> */}
            </div>

            {/* 初回ご注文日時 */}
            {/* <div className={style.subscriptionContractBodyPaymentFirstOrderDate}>
              <p className={base.baseGray400}>
                初回ご注文日時:{' '}
                <span className={base.baseBlack600}>{dayjs(subscription.createdAt).format('YYYY/MM/DD(ddd)')}</span>
              </p>
            </div> */}

            {/* 定期購入ID */}
            {/* <div className={style.subscriptionContractBodyPaymentSubscriptionId}>
              <p className={base.baseGray400}>
                定期購入ID: <span className={base.baseBlack600}>{parseGid(subscription.subscriptionContractId)}</span>
              </p>
            </div> */}
          </div>
          {/* 支払情報上部セクションここまで */}

          {/* 支払情報下部セクション */}
          {/* <div className={style.subscriptionContractBodyPaymentBottom}>
            <p className={`${base.buttonLink}`}>定期注文を確認する</p>
          </div> */}
          {/* 支払情報下部セクションここまで */}
        </div>
        {/* 支払い情報 */}
      </div>
      {/* 契約情報本体ここまで */}
    </div>
  );
};

export default SubscriptionItem;
